import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const EmptyCostCodeContainerBoxStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
  flexGrow: { sm: 1 },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    height: 100%;
    margin: ${theme.spacings[400]};
    background-color: ${theme.colors.white};
    border-radius: ${theme.spacings[200]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  `};
`;

interface CostCodesContainerBoxProps {
  showDateHeader: boolean;
  hourTypeCount: number;
}

export const CostCodesContainerBoxStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})<CostCodesContainerBoxProps>`
  ${({ showDateHeader, hourTypeCount }) => css`
    overflow: clip auto;
    //DateHeader (44px) + CrewHeader (98px) + CrewTimesheetSummary (166px for 1 hourtype(30px)) + Action bar (48 + 8px) + Bottom Buffer (16px)
    //Fixed containers:CrewHeader (98px) + CrewTimesheetSummary (136px for 0 hourtype(30px)) + Action bar (48 + 8px) + Bottom Buffer (16px) = 306px
    height: calc(100vh - (306px + ${showDateHeader ? 44 : 0}px + ${hourTypeCount * 30}px));
  `};
`;
